export const h1bRates = [
  {
    year: "FY2021",
    registrations: 269424,
    selections: 124415,
    selectionRate: 46.2,
    rounds: 2,
  },
  {
    year: "FY2022",
    registrations: 301447,
    selections: 131924,
    selectionRate: 43.8,
    rounds: 3,
  },
  {
    year: "FY2023",
    registrations: 474421,
    selections: 127600,
    selectionRate: 26.9,
    rounds: 2,
  },
  {
    year: "FY2024",
    registrations: 758994,
    selections: 188400,
    selectionRate: 24.8,
    rounds: 3,
  },
  {
    year: "FY2025",
    registrations: 470342,
    selections: 135137,
    selectionRate: 28.7,
    rounds: 2,
  },
  {
    year: "FY2026",
    registrations: 343981,
    selections: 120141,
    selectionRate: 35,
    rounds: 1,
  },
];

export const wageWeights = [
  {
    level: 1,
    entries: 1,
    description: "Entry-level (~17th percentile)",
    descriptionZh: "入门级（约第17百分位）",
  },
  {
    level: 2,
    entries: 2,
    description: "Qualified (~34th percentile)",
    descriptionZh: "合格级（约第34百分位）",
  },
  {
    level: 3,
    entries: 3,
    description: "Experienced (~50th percentile)",
    descriptionZh: "经验级（约第50百分位）",
  },
  {
    level: 4,
    entries: 4,
    description: "Fully competent (~67th percentile)",
    descriptionZh: "熟练级（约第67百分位）",
  },
];

export const h1bCapStructure = {
  regularCap: 65000,
  advancedDegreeCap: 20000,
  total: 85000,
};
